var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodebox1 = function SvgCodebox1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#F6F6F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.375 56.667V28.333a7.084 7.084 0 0 0-3.542-6.127L46.042 8.04a7.083 7.083 0 0 0-7.084 0L14.167 22.206a7.082 7.082 0 0 0-3.542 6.127v28.334a7.084 7.084 0 0 0 3.542 6.127L38.958 76.96a7.083 7.083 0 0 0 7.084 0l24.791-14.166a7.082 7.082 0 0 0 3.542-6.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.563 32.208 42.5 23l15.938 9.208M26 34v18.655L42 62M59 33v19.32L43 62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.581 24.65 42.5 42.535 73.419 24.65M42.5 78.2V42.5"
  }))));
};
export default SvgCodebox1;